var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tableWrap"
  }, [_c('el-table', {
    staticClass: "wdb100",
    attrs: {
      "data": _vm.adjustmentList,
      "border": "",
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adjustmentNo",
      "label": "Quotation (V)",
      "align": "center",
      "width": "140px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "Create Date",
      "align": "center",
      "width": "250px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "country",
      "label": "Country",
      "align": "center",
      "width": "200px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "applyReason",
      "label": "Description / Apply Reason",
      "align": "center",
      "min-width": "180px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "align": "center",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.adjustmentStatusFormat(scope.row.status)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Generic Invoice",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$customerIn, _scope$row$customerIn2;

        return [scope.row.customerInvoice ? [((_scope$row$customerIn = scope.row.customerInvoice) === null || _scope$row$customerIn === void 0 ? void 0 : _scope$row$customerIn.invoiceType) == 1 ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function click($event) {
              return _vm.invoiceLink(scope.row.customerInvoice.invoiceNumber);
            }
          }
        }, [_vm._v(" Invoice ")]) : _vm._e(), ((_scope$row$customerIn2 = scope.row.customerInvoice) === null || _scope$row$customerIn2 === void 0 ? void 0 : _scope$row$customerIn2.invoiceType) == 2 ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function click($event) {
              return _vm.invoiceLink(scope.row.customerInvoice.invoiceNumber);
            }
          }
        }, [_vm._v(" Credit Invoice ")]) : _vm._e()] : _vm._e()];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }